<template>
  <div class="hello">
    <h1>Our Terms &amp; Conditions</h1>
  </div>
</template>

<script>
export default {

}
</script>



// WEBPACK FOOTER //
// Terms.vue?6434b163